import { del, EndPoints, get } from '../';
export function list() {
    return get(EndPoints.medias, { all: 1 });
}
export function deleteMedia(request) {
    return del("" + EndPoints.mediasDelete, request);
}
